import { fetch } from "../../index";
import { author } from "../../queries/author";

import { GRAPHQL_URL } from "../../constants";

import { isValidContentId } from "../../../../utils/dataTransform/ContentItem/library";
import { HttpError } from "../../../../utils/errors/http";
import { HTTP_NOT_FOUND } from "../../../../constants/http";

/**
 * Fetch Author data from GraphQL
 *
 * @param {string} contentId the contentId of the author
 * @return {Promise<void>} the result of the query
 */
export async function fetchAuthor(contentId, page = 1) {
    if (!isValidContentId(contentId)) {
        throw new HttpError(HTTP_NOT_FOUND, "Not Found");
    }

    return await fetch(GRAPHQL_URL, {
        query: author(contentId, page),
    });
}
